package org.vreo.devicehub.features.core.data.protocolBuffer.mappers

import vreo.volt.protocol.VideoConfiguration
import vreo.volt.protocol.ZoomAndFocus

import org.vreo.devicehub.features.core.domain.device.videoCameraConfig.CameraResolution
import org.vreo.devicehub.features.core.domain.device.videoCameraConfig.VideoConfig

/**
 * Converts a [VideoConfig] to a [VideoConfiguration] proto message.
 */
fun VideoConfig.toVideoConfigurationProto(): VideoConfiguration {
    val zoomConfig = ZoomAndFocus(
        zoom = this.zoom,
        focus = this.focus,
        zoom_mini = this.zoomMini ?: -1f,
        zoom_max = this.zoomMax ?: -1f,
        focus_mini = this.focusMini ?: -1f,
        focus_max = this.focusMax ?: -1f,
    )

    return VideoConfiguration(
        height = this.resolution.height,
        width = this.resolution.width,
        frame_rotation = this.frameRotation.toFrameRotationProto(),
        target_brightness = this.targetBrightness.toInt(),
        max_exposure_time_us = this.maxExposureTimeUs.toInt(),
        min_exposure_time_us = this.minExposureTimeUs.toInt(),
        max_gain = this.maxGain,
        min_gain = this.minGain,
        zoom_config = zoomConfig
    )
}

/**
 * Converts a [VideoConfiguration] proto message to a [VideoConfig].
 */
fun VideoConfiguration.toVideoConfig(): VideoConfig {
    val resolution = when (this.height) {
        1080 -> CameraResolution.FULL_HD
        1440 -> CameraResolution.TWO_K
        2160 -> CameraResolution.FOUR_K
        else -> CameraResolution.HD
    }

    return VideoConfig(
        resolution = resolution,
        frameRotation = this.frame_rotation.toVideoFrameRotation(),
        targetBrightness = this.target_brightness.toFloat(),
        maxExposureTimeUs = this.max_exposure_time_us.toFloat(),
        minExposureTimeUs = this.min_exposure_time_us.toFloat(),
        maxGain = this.max_gain,
        minGain = this.min_gain,
        zoom = this.zoom_config?.zoom ?: 0f,
        focus = this.zoom_config?.focus ?: 0f,
        zoomMini = this.zoom_config?.zoom_mini?.let {
            if (it == -1f) null else it
        },
        zoomMax = this.zoom_config?.zoom_max?.let {
            if (it == -1f) null else it
        },
        focusMini = this.zoom_config?.focus_mini?.let {
            if (it == -1f) null else it
        },
        focusMax = this.zoom_config?.focus_max?.let {
            if (it == -1f) null else it
        }
    )
}